import { styled } from '@clickcease/cc-client-components-lib'

export const AuthTemplateStyled = styled('div', {
  display: 'flex',

  '@bp1': {
    flexDirection: 'column',

    height: '100vh',
  },
})

export const AuthTemplateGraphic = styled('div', {
  width: '40%',
  height: '100vh',

  ['> img']: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  '@bp1': {
    width: '100%',
    height: 'auto',
    position: 'absolute',
    bottom: '0px',
  },
})

export const AuthTemplateContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '60%',
  position: 'relative',
  alignContent: 'center',
  padding: '25px 30px 0px 30px',

  ['> img']: {
    width: '147px',
    height: '38px',
  },

  '@bp1': {
    padding: '25px 6% 0px 6%',
    width: '88%',
    height: '93vh',
  },
})

export const AuthPageContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  position: 'relative',
  justifyContent: 'center',
  alignItems: 'center',
})

export const LogoContainer = styled('div', {
  position: 'absolute',
  top: '0px',
  left: '24px',
})

export const LanguageSelectWrapper = styled('div', {
  display: 'flex',
  position: 'absolute',
  top: '20px',
  right: '47px',
})
